import { CssKeyframes } from '@chakra-ui/react';
import { TokenDefinition } from 'node_modules/@chakra-ui/react/dist/types/styled-system/types';

/** CSS animations */
const animations: TokenDefinition['animations'] = {
  loaderSpin: { value: 'rotating 1.6s infinite cubic-bezier(0.17, 0.67, 0.83, 0.17)' },
  pulsate: { value: 'pulsate infinite 4s' },
  shakeAnimation: { value: 'shakeAnimation 0.2s ease-in-out 0s 2' },
  transcriptWordAnimation: { value: 'transcriptWordAnimation 1s' },
};

const keyframes: CssKeyframes = {
  rotating: {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  pulsate: {
    '0%': {
      opacity: 0.5,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.5,
    },
  },
  collapseSidebar: {
    from: {
      width: '260px',
    },
    to: {
      width: '72px',
    },
  },
  expandSidebar: {
    from: {
      clipPath: 'inset(0 70% 0 0)',
    },
    to: {
      clipPath: 'inset(0 0 0 0)',
    },
  },
  shakeAnimation: {
    '0%': {
      marginLeft: '0rem',
    },
    '25%': {
      marginLeft: '0.5rem',
    },
    '75%': {
      marginLeft: '-0.5rem',
    },
    '100%': {
      marginLeft: '0rem',
    },
  },
  transcriptWordAnimation: {
    '0%': { top: 0, bottom: '0px' },
    '16%': { top: '-3px', bottom: '-3px' },
    '32%': { top: '3px', bottom: '3px' },
    '48%': { top: '1px', bottom: '1px' },
    '64%': { top: '-2px', bottom: '-2px' },
    '80%': { top: '3px', bottom: '3px' },
    '96%': { top: '-1px', bottom: '-1px' },
  },
};

export { animations, keyframes };
